import { loadAndApplyStoreBranding } from './utils/appBranding';

loadAndApplyStoreBranding();
